import inherited from 'mastodon/locales/sr.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
